@if (isLoggedIn) {
  <div class="network-view">
    <p-tabView (onChange)="onTabChange($event)">
      <!-- Whenever tabs are reordered or modified so that their indexes change,
      all references to "selectedTab" must be updated to reflect the updated
      indexes (for example, see the "Events" tab below) -->
      <p-tabPanel header="Devices/Maps" headerStyleClass="data-tab" [selected]="true">
        <devices [selected]="selectedTab == DevicesTabIndex"></devices>
      </p-tabPanel>
      <p-tabPanel header="Reports" headerStyleClass="data-tab">
        <reports></reports>
      </p-tabPanel>
      <p-tabPanel header="Events" headerStyleClass="data-tab">
        <events [network]="network" [selected]="selectedTab == EventsTabIndex"></events>
      </p-tabPanel>
      <p-tabPanel header="Network Settings" headerStyleClass="config-tab">
        <network-settings [target]="network"></network-settings>
        <email-settings [target]="network"></email-settings>
        <map-draw-settings [target]="network"></map-draw-settings>
        <div style="height: 500px;"></div>
      </p-tabPanel>
      <p-tabPanel header="Agents" headerStyleClass="config-tab">
        <agent-list [network]="network"></agent-list>
      </p-tabPanel>
      @if (canViewCredentials) {
        <p-tabPanel header="Protocols/Credentials" headerStyleClass="config-tab">
          <credentials [target]="network"></credentials>
        </p-tabPanel>
      }
      <p-tabPanel header="Device Filters" headerStyleClass="config-tab">
        <device-filter-list [target]="network"></device-filter-list>
      </p-tabPanel>
      <p-tabPanel header="Manual Links" headerStyleClass="config-tab">
        <user-link-list [target]="network"></user-link-list>
      </p-tabPanel>
      <p-tabPanel header="PRTG Export" headerStyleClass="config-tab">
        <nvtn-prtg-export-config [target]="network"></nvtn-prtg-export-config>
      </p-tabPanel>
      <p-tabPanel header="Monitors" headerStyleClass="monitor-tab">
        <monitors [selected]="selectedTab == MonitorsTabIndex"></monitors>
      </p-tabPanel>
      <p-tabPanel header="Tools" headerStyleClass="config-tab">
        <tools></tools>
      </p-tabPanel>
    </p-tabView>
    <span class="uv-save-button">
      <button type="button" pButton icon="fa fa-save" (click)="onSave()" [disabled]="!isSaveEnabled()"
        label="Save Network Changes">
      </button>
      <!--{{ network.HasChanges ?? "None" }}-->
    </span>
    <p-dialog [(visible)]="showInvalidTempChangesDialog" appendTo="body">
      <p-header>
        <span>Invalid Changes</span>
      </p-header>
      <p>
        Invalid changes have been made in the following tabs and cannot be saved.
      </p>
      <ul>
        @for (tabName of tabsWithErrors; track tabName) {
          <li>{{tabName}}</li>
        }
      </ul>
      <p>
        Select one of the options below.
      </p>
      <p-footer>
        <button type="button" pButton (click)="onDiscardTempChanges()" label="Discard Changes"></button>
        <button type="button" pButton (click)="onCancelSave()" label="Cancel"></button>
      </p-footer>
    </p-dialog>
  </div>
}

